import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
const NotFound = () => import("@/pages/System/NotFoundPage.vue");
// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import OrderCustomer from "@/pages/OrderCustomer/List.vue";
const Login = () => import("@/pages/Login");
import AnonymousOrder from "@/pages/AnonymousOrder/Order.vue";
import TicketReservations from "@/pages/TicketReservations/TicketReservations.vue";
import Location from "@/pages/Location/List.vue";
import Report from "@/pages/Dashboard/Report.vue";
import Notifications from "@/pages/Notifications/Notifications.vue";
const AccessDenied = () => import("@/pages/System/AccessDenied.vue");
const Home = () => import("@/pages/Home.vue");
const appName = " | CETA";

const routes = [
  {
    path: "/login",
    name: window.__t('js.dang_nhap_1d5caf09'),
    component: Login,
    meta: {
      auth: false,
      title: window.__t('js.dang_nhap_1d5caf09') + appName,
    },
  },
  {
    path: "/anonymous-order",
    name: window.__t('js.don_hang_vang_lai'),
    component: AnonymousOrder,
    meta: {
      auth: false,
      title: window.__t('js.don_hang_vang_lai') + appName,
    },
  },
  {
    path: "/ticket-reservations",
    name: window.__t('js.dat_ve_truc_tuyen'),
    component: TicketReservations,
    meta: {
      auth: false,
      title: window.__t('js.dat_ve_truc_tuyen') + appName,
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
    meta: {
      requiresAuth: false,
    },
  },
  { path: "/access-denied", component: AccessDenied },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/report",
    meta: {
      auth: true,
    },
    
    children: [
      {
        path: "home",
        name: window.__t('js.trang_chu'),
        component: Home,
        meta: {
          auth: true,
        },
      },
      {
        path: "report",
        name: window.__t('js.tong_quan'),
        component: Report,
        meta: {
          auth: true,
          title: window.__t('js.tong_quan') + appName,
        },
      },
      {
        path: "order-customer",
        name: window.__t('js.don_hang'),
        component: OrderCustomer,
        meta: {
          auth: true,
          title: window.__t('js.don_hang') + appName,
        },
      },
      {
        path: "dashboard",
        name: window.__t('js.lich_bieu'),
        component: Dashboard,
        meta: {
          auth: true,
          title: window.__t('js.lich_bieu') + appName,
        },
      },
      {
        path: "location",
        name: window.__t('js.dia_chi'),
        component: Location,
        meta: {
          auth: true,
          title: window.__t('js.dia_chi') + appName,
        },
      },
      
    ],
  },
  
  
];


export default routes;
